/**
 * Market pre-launch component
 *
 * Drives the "+ more" control of the brands preview: each click advances the
 * <swiper-slider> carousel by one brand and, once the last brand is visible,
 * goes back to the first one (Swiper 7 has no `rewind` option).
 *
 * @module market-pre-launch
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = 'market-pre-launch';

if (!customElements.get(customElements.component)) {

    class MarketPreLaunch extends HTMLElement {

        /**
         * Market pre-launch web component
         *
         * @constructor
         */
        constructor() {

            super();

            const moreButton = this.querySelector('[data-pre-launch-more]');

            if (moreButton) {
                moreButton.addEventListener('click', this.showMoreBrands.bind(this));
            }
        }

        /**
         * Advance the brands carousel by one slide, rewinding at the end
         *
         * @return {undefined}
         */
        showMoreBrands() {

            const slider = this.querySelector('swiper-slider').slider;

            if (slider.isEnd) {
                slider.slideTo(0);
            } else {
                slider.slideNext();
            }
        }
    }

    customElements.define(customElements.component, MarketPreLaunch);
}
